/**
 * Banner 状态枚举
 */
export enum BannerStatus {
  /** 已发布 */
  PUBLISHED = 'PUBLISHED',
  /** 已下架 */
  OFFLINE = 'OFFLINE',
  /** 草稿 */
  DRAFT = 'DRAFT'
}

/**
 * Banner 跳转类型枚举
 */
export enum BannerLinkType {
  /** 跳转到项目详情 */
  PROJECT = 'PROJECT',
  /** 跳转到外部链接 */
  EXTERNAL = 'EXTERNAL',
  /** 不跳转 */
  NONE = 'NONE'
}

/**
 * Banner 数据模型
 */
export interface Banner {
  /** 唯一标识 */
  id: string;
  
  /** Banner 标题 */
  title: string;
  
  /** Banner 图片 URL */
  imageUrl: string;
  
  /** 跳转类型 */
  linkType: BannerLinkType;
  
  /** 跳转链接（linkType 为 PROJECT 时是项目 ID，EXTERNAL 时是外部 URL） */
  linkUrl?: string;
  
  /** 排序权重（数字越大越靠前） */
  sortOrder: number;
  
  /** 状态 */
  status: BannerStatus;
  
  /** 开始时间（可选，用于定时发布） */
  startTime?: string;
  
  /** 结束时间（可选，用于定时下架） */
  endTime?: string;
  
  /** 创建时间 */
  createTime: string;
  
  /** 更新时间 */
  updateTime: string;
  
  /** 创建人 ID */
  creatorId?: string;
  
  /** 创建人名称 */
  creatorName?: string;
}

